import React from 'react';
import classNames from 'classnames';

import { getDecimalSeparator } from '~shared/utils/currencyUtils';
import KeyboardButton from './KeyboardButton';
import {
    useKeyboard,
} from '~Betslip/store/keyboardContext';

import {
    useSsSelector as useSelector,
} from '~SpectateStore';

import {
    selectBetslipGTMComponent,
} from '~Betslip/selectors/uiSelectors';

import {
    sendHapticFeedbackLight,
} from '~spa/Utils/HapticFeedback';

const NumberKeys = () => {
    const numberKeys1to9 = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
    const testIdPrefix = 'betslip-keyboard;btnvalue';

    const decimalSeparator = getDecimalSeparator();
    const keys = [
        ...numberKeys1to9,
        decimalSeparator,
        '0',
        'delete',
    ];

    const {
        addChar,
        removeLastChar,
    } = useKeyboard();

    const gtmComponent = useSelector(selectBetslipGTMComponent);

    return (
        <ul className="fullslip__number-keys">
            {
                keys.map((keyText) => {
                    const isDelete = keyText === 'delete';
                    const buttonClass = classNames('fullslip__number-key', {
                        'fullslip__back-key': isDelete,
                    });

                    const clickHandler = () => {
                        if (isDelete) {
                            removeLastChar();
                        } else {
                            addChar(keyText);
                        }
                        sendHapticFeedbackLight();
                    };

                    const dataTestId = keyText === decimalSeparator ?
                        `${testIdPrefix}dot` : `${testIdPrefix}${keyText}`;

                    const gtmEnd = keyText === decimalSeparator ? 'punctuation' : keyText;
                    const gtmAttribute = `${gtmComponent};stake-area;${gtmEnd}`;

                    return (
                        <li
                            className={buttonClass}
                            key={keyText}
                        >
                            <KeyboardButton
                                keyText={keyText}
                                clickHandler={clickHandler}
                                dataTestId={dataTestId}
                                gtmAttribute={gtmAttribute}
                            />
                        </li>
                    );
                })
            }
        </ul>
    );
};

export default NumberKeys;
